<template>
  <header :class="{ active: backgroundActive }">
    <img alt="logo" src="../assets/images/logo.png">
    <nav>
      <NavLink anchor="intro" :title="$t('header.buttons.intro')"/>
      <NavLink anchor="contact" :title="$t('header.buttons.contact')"/>
    </nav>
  </header>
</template>

<script>
import NavLink from "./NavLink.vue";

export default {
  name: "Header",
  data: () => ({
    backgroundActive: false
  }),
  components: {
    NavLink
  },
  methods: {
    handleScroll() {
      this.backgroundActive = window.scrollY > 100;
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>

<style scoped>
header {
  position: fixed;
  top: 0;
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  align-items: center;
  padding: 2em;
}

header.active {
  background-image: linear-gradient(to bottom right, #4595ee, #00fe79);
}

header img,
nav {
  max-width: 50%;
}

@media only screen and (max-width: 800px) {
  header nav {
    display: flex;
    flex-flow: column wrap;
  }

  header nav a {
    margin: 0.2em;
  }
}
</style>
